import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Versus = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      stroke={stroke}
      {...rest}
    >
      <path d="M11.15 9.736 9.414 8l6.293-6.293A1 1 0 1 0 14.293.293L8 6.586 1.707.293A1 1 0 1 0 .293 1.707L6.586 8 4.85 9.736a3.99 3.99 0 0 0-4.85.607l2.121 2.122-1.828 1.828a1 1 0 1 0 1.414 1.414l1.828-1.828L5.657 16a3.991 3.991 0 0 0 .607-4.85L8 9.414l1.736 1.736a3.991 3.991 0 0 0 .607 4.85l2.122-2.121 1.828 1.828a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414l-1.828-1.828L16 10.343a3.99 3.99 0 0 0-4.85-.607z" />
    </svg>
  );
};

Versus.displayName = 'Versus';
